/**
 * External Imports
 */
import { useState } from 'react';

/**
 * Nexus Imports
 */
import { NeuIcon } from '@neutron/react';
import { useAnalyticsApi } from '@shared-web-analytics/react/dist';

/**
 * Internal Imports
 */
import { logHelpClick } from '../../../utils/analyticsHelpers';

/**
 * Styling Imports
 */
import {
  InlineRelativeContainer,
  QuickLinksDropDownContainer,
  PopContent,
  PopItem,
  StyledNavTab
} from './NavDropdown.styles';
import { useUserRolesRef } from '../../../services/UserRoles';

const QuickLinksDropdown = () => {
  const [isQuickLinksOpen, setIsQuickLinksOpen] = useState(false);
  const [, setShowPopover] = useState(false);
  const { logTrackingEvent } = useAnalyticsApi();
  const { isPatientRounder, isEmployeeRounder } = useUserRolesRef();

  return (
    <>
      <StyledNavTab
        unit="tab"
        onBlur={() => setIsQuickLinksOpen(false)}
        onClick={() => setIsQuickLinksOpen(!isQuickLinksOpen)}
      >
        <div id="QuickLinks-Icon" className="d-flex align-items-center">
          Quick Links
          <NeuIcon color="gray" size="1x">
            arrow_drop_down
          </NeuIcon>
        </div>
      </StyledNavTab>

      <InlineRelativeContainer onBlur={() => setShowPopover(false)}>
        <QuickLinksDropDownContainer showPopover={isQuickLinksOpen}>
          {(isPatientRounder || isEmployeeRounder) && (
            <PopItem
              id="Resolve"
              className="dropdown-hover-item"
              role="option"
              tabIndex={0}
              onMouseDown={() => {
                window.open('https://resolve.hcahealthcare.cloud/', '_blank');
              }}
            >
              <PopContent>
                Resolve
                <NeuIcon color="blue" size="1x">
                  launch
                </NeuIcon>
              </PopContent>
            </PopItem>
          )}
          <PopItem
            id="MyPath"
            className="dropdown-hover-item"
            role="option"
            tabIndex={0}
            onMouseDown={() => {
              window.open('http://hcahealthcaremypath.com/', '_blank');
            }}
          >
            <PopContent>
              My Path
              <NeuIcon color="blue" size="1x">
                launch
              </NeuIcon>
            </PopContent>
          </PopItem>
          <PopItem
            id="Recognition"
            className="dropdown-hover-item"
            role="option"
            tabIndex={0}
            onClick={() => {
              window.open(
                'https://colleaguerecognition.isrewards.com/',
                '_blank'
              );
            }}
            onKeyDown={event => {
              if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                window.open(
                  'https://colleaguerecognition.isrewards.com/',
                  '_blank'
                );
              }
            }}
          >
            <PopContent>
              Recognition
              <NeuIcon color="blue" size="1x">
                launch
              </NeuIcon>
            </PopContent>
          </PopItem>
          <PopItem
            id="SharePoint"
            className="dropdown-hover-item"
            role="option"
            tabIndex={0}
            onMouseDown={() => {
              logTrackingEvent(logHelpClick('sharepoint'));
              window.open(
                'https://hcahealthcare.sharepoint.com/sites/CORP-CDI/SitePages/Orbit.aspx',
                '_blank'
              );
            }}
          >
            <PopContent>
              Orbit SharePoint Site
              <NeuIcon color="blue" size="1x">
                launch
              </NeuIcon>
            </PopContent>
          </PopItem>
          {/* <PopItem
            id="Healthstream"
            className="dropdown-hover-item"
            role="option"
            tabIndex={0}
            onMouseDown={() => {
              logTrackingEvent(logHelpClick('health-stream'));
              window.open(
                'https://www.healthstream.com/hlc/common/course/quicklinks.aspx?oid=a86b970c-a5b3-da11-8139-000423acef71&quickLink=YT0xJnRzPTIwMjItMDgtMjlUMTY6MTk6NTImY2lkPTFkM2QyMjFjLTQ2MjUtZWQxMS04MGY3LTAwNTA1NmIxMzRlYyZjdj0w',
                '_blank'
              );
            }}
          >
            <PopContent>
              HealthStream{' '}
              <NeuIcon color="blue" size="1x">
                launch
              </NeuIcon>
            </PopContent>
          </PopItem> */}
          <PopItem
            id="HR-Employee-Rounding"
            className="dropdown-hover-item"
            role="option"
            tabIndex={0}
            onMouseDown={() => {
              logTrackingEvent(logHelpClick('hr-emp-rounding'));
              window.open(
                'https://connect.medcity.net/web/engret/blog ',
                '_blank'
              );
            }}
          >
            <PopContent>
              HR Employee Rounding{' '}
              <NeuIcon color="blue" size="1x">
                launch
              </NeuIcon>
            </PopContent>
          </PopItem>
        </QuickLinksDropDownContainer>
      </InlineRelativeContainer>
    </>
  );
};

export default QuickLinksDropdown;
